import { Calendar, CircleDot, DollarSign, Hash, MapPin, Phone, SquareCheck, ToggleLeft, Type, Upload } from "lucide-react";
import { AttributeType } from "../../clients/Purchaser/Attributes";
import type { AttributeFilterOperator } from "./types";

export const AttributeTypeIconMap = {
    [AttributeType.STRING]: Type,
    [AttributeType.FILE]: Upload,
    [AttributeType.NUMBER]: Hash,
    [AttributeType.DATE]: Calendar,
    [AttributeType.PHONE]: Phone,
    [AttributeType.SELECT]: CircleDot,
    [AttributeType.MULTI_SELECT]: SquareCheck,
    [AttributeType.PRICE]: DollarSign,
    [AttributeType.ADDRESS]: MapPin,
    [AttributeType.BOOLEAN]: ToggleLeft,
};

export const AttributeTypeDisplayMap = {
    [AttributeType.STRING]: "Text",
    [AttributeType.FILE]: "File",
    [AttributeType.NUMBER]: "Number",
    [AttributeType.DATE]: "Date",
    [AttributeType.PHONE]: "Phone Number",
    [AttributeType.SELECT]: "Dropdown",
    [AttributeType.MULTI_SELECT]: "Multiple Choice",
    [AttributeType.PRICE]: "Price",
    [AttributeType.ADDRESS]: "Address",
    [AttributeType.BOOLEAN]: "Boolean",
};

export const NumberOperatorChipLabel: Record<AttributeFilterOperator, string> = {
    eq: "equal to",
    gt: "greater than",
    lt: "less than",
    gte: "greater than or equal to",
    lte: "less than or equal to",
    between: "between",
};

// eq/gt/lt are defined for forward-compat — the UI only emits gte/lte/between today,
// but a filter showing up via URL/API shouldn't render a blank operator.
export const DateOperatorChipLabel: Record<AttributeFilterOperator, string> = {
    eq: "on",
    gt: "after",
    lt: "before",
    gte: "on or after",
    lte: "on or before",
    between: "in",
};
